import { render, staticRenderFns } from "./ChangeUserBalance.vue?vue&type=template&id=58ab5417&scoped=true&"
import script from "./ChangeUserBalance.vue?vue&type=script&lang=js&"
export * from "./ChangeUserBalance.vue?vue&type=script&lang=js&"
import style0 from "./ChangeUserBalance.vue?vue&type=style&index=0&id=58ab5417&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ab5417",
  null
  
)

export default component.exports